import BackendService from "../../../backend/controller/BackendService";
import CharacterModel from "../../../characters/model/CharacterModel";
import PlayerModel from "../../../player/model/PlayerModel";
import Conversation from "../../model/Conversation";
import GameConversationMessage from "../../model/GameConversationMessage";
import LlmConversationMessage, { LlmMessageSender } from "../../model/LlmConversationMessage";
import ConversationState from "./ConversationState";
import PlayerTurnConversationState from "./PlayerTurnConversationState";

export default class AiTurnConversationState extends ConversationState {
    /**
     * 
     * @param {string} chapterId
     * @param {Conversation} conversation 
     * @param {CharacterModel[]} characters 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationState>}
     */
    async execute(chapterId, conversation, characters, backendService, playerModel) {
        try {
            const roleplayMessageOutput = await backendService.roleplay({
                chapterId: chapterId,
                conversationId: conversation.id,
                phaseId: conversation.currentPhaseId,
                turnsInThisPhase: conversation.getTurnsForCurrentPhase(),
                conversationHistory: conversation.conversationHistoryForLLM,
                characters,
            });

            // The back-end requires the assistant message to be a single string, or it gets confused.
            // For the game itself we want to keep the messages separate.
            const combinedRoleplayMessage = roleplayMessageOutput.characters.map(characterOutput => `${characterOutput.name}: ${characterOutput.dialogue}`).join('\n');
            conversation.addConversationHistory({
                llmConversationMessages: [new LlmConversationMessage(LlmMessageSender.ASSISTANT, combinedRoleplayMessage)],
                gameConversationMessages: roleplayMessageOutput.characters.map(characterOutput => new GameConversationMessage(characterOutput.name, characterOutput.dialogue, characterOutput.action)),
            });

            const nextState = new PlayerTurnConversationState();
            return Promise.resolve(nextState);
        } catch (error) {
            console.error(`[${AiTurnConversationState.name}] execute error: `, error);
            return Promise.reject(error);
        }
    }
}

AiTurnConversationState.EVENT_TURN_RESET = 'AiTurnConversationState.EVENT_TURN_RESET';